export default __webpack_public_path__ + "static/media/startup.5f124ebf.svg";